export default Object.freeze({
  QUERY: 'query',
  PUBLICATION: 'publication'
})
